import { registerComponent, triggerEvent } from "helpers";
import WYATTDialog from "wyatt-dialog";

registerComponent(
  "wyatt-modal",
  class WyattModal extends WYATTDialog {
    open(event) {
      super.open(event);

      triggerEvent(this.dialog, "modalOpen");
    }

    close() {
      super.close();

      triggerEvent(this.dialog, "modalClose");
    }
  },
);
